<template>
  <popover v-if="withBubble" :content="title" :trigger="triggerTooltip">
    <a :class="classObject" @click.prevent="save" v-html="value"></a>
  </popover>
  <a v-else :class="classObject" @click.prevent="save" v-html="value"></a>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import isTouchDevice from '@/lib/is-touch-device.js';
import { Popover } from 'vue-bootstrap';

export default {
  components: {
    Popover
  },
  props: {
    enabled: {
      type: Boolean,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    entrySlug: {
      type: String,
      required: true
    },
    scoreSetSlug: {
      type: String,
      required: true
    },
    canRemove: {
      type: Boolean,
      required: true
    },
    withBubble: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    selected: false
  }),
  computed: {
    ...mapGetters('topPick', [
      'entryPreference',
      'entryPreferenceSaving',
      'pickTitle'
    ]),
    saving() {
      return this.entryPreferenceSaving(this.entrySlug) === this.value;
    },
    title() {
      return this.pickTitle(this.value) || '';
    },
    active() {
      return this.entryPreference(this.entrySlug) === this.value;
    },
    triggerTooltip() {
      return !this.active && this.title ? 'hover' : 'manual';
    },
    classObject() {
      return {
        'top-pick-preference': true,
        hover: !isTouchDevice(),
        active: this.active,
        disabled: !this.enabled,
        saving: this.saving
      };
    }
  },
  methods: {
    ...mapActions('topPick', ['saveEntryPreference']),
    save(event) {
      if ((!this.active || this.canRemove) && !this.saving && this.enabled) {
        this.saveEntryPreference({
          scoreSetSlug: this.scoreSetSlug,
          entrySlug: this.entrySlug,
          value: this.active ? 0 : this.value,
          category: this.category
        });
      }
    }
  }
};
</script>
